import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_pets_dog: FaireCategoryEntity = {
  token: "cat_pets-dog",
  type: "category",
  name: "Dog",
  level: 2,
  parentToken: "cat_pets",
  href: "/category/pets/dog",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
